// src/component/AdminPanelTelegramBind.jsx
import React, { useEffect, useState } from "react";
import { authFetch } from "../utils/authFetch";

export default function AdminPanelTelegramBind() {
  const [profile, setProfile] = useState(null);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState({ ok: "", err: "" });

  const reload = async () => {
    const { data, status } = await authFetch("/api/accounts/profile/");
    if (status === 200) setProfile(data || {});
  };
  useEffect(() => { reload(); }, []);

  const adminTgId = profile?.telegram_admin_id ?? null;

  const bind = async (e) => {
    e?.preventDefault?.();
    setBusy(true); setMsg({ ok: "", err: "" });
    const { status, data } = await authFetch("/api/accounts/bind-telegram-admin/", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code: code.trim() }),
    });
    if (status === 200) { 
      setMsg({ ok: "Telegram привязан", err: "" }); 
      setCode(""); 
      await reload(); 
    }
    else setMsg({ ok: "", err: data?.detail || "Не удалось привязать" });
    setBusy(false);
  };

  const unbind = async () => {
    setBusy(true); setMsg({ ok: "", err: "" });
    const { status, data } = await authFetch("/api/accounts/unbind-telegram-admin/", { method: "POST" });
    if (status === 200) { setMsg({ ok: "Telegram отвязан", err: "" }); await reload(); }
    else setMsg({ ok: "", err: data?.detail || "Не удалось отвязать" });
    setBusy(false);
  };

  return (
    <section className="space-y-4">
      <h2 className="text-xl font-bold">Telegram (админ-бот)</h2>

      <div className="rounded-xl ring-1 ring-gray-200 bg-white p-4 shadow-sm">
        <div className="text-sm text-gray-700">
          Статус:&nbsp;
          {adminTgId ? (
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold ring-1 bg-emerald-50 text-emerald-700 ring-emerald-200">
              привязан · chat_id: {adminTgId}
            </span>
          ) : (
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold ring-1 bg-gray-50 text-gray-700 ring-gray-200">
              не привязан
            </span>
          )}
        </div>

        <p className="mt-2 text-sm text-gray-600">
          1) Откройте админ-бота и выполните <b>/bind</b> — бот пришлёт код.<br/>
          2) Вставьте код и нажмите «Привязать».
        </p>

        {/* Показываем форму, если Telegram не привязан */}
        {!adminTgId && (
          <form onSubmit={bind} className="mt-3 flex flex-col sm:flex-row gap-2">
            <input
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Код из Telegram"
              required
              className="flex-1 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-400"
            />
            <button
              type="submit"
              disabled={busy || !code.trim()}
              className={`px-4 py-2 rounded-md text-white font-semibold shadow ${
                busy ? "bg-orange-300 cursor-wait" : "bg-orange-500 hover:bg-orange-600"
              }`}
            >
              {busy ? "Привязываем…" : "Привязать"}
            </button>
          </form>
        )}

        {/* После привязки показываем сообщение об успешной привязке */}
        {adminTgId && (
          <>
            <div className="mt-2 text-green-700 bg-emerald-50 ring-1 ring-emerald-200 rounded px-3 py-2 text-sm">
              ✓ Telegram успешно привязан
            </div>
            <button
              onClick={unbind}
              disabled={busy}
              className={`mt-4 px-4 py-2 rounded-md text-white font-semibold shadow ${
                busy ? "bg-orange-300 cursor-wait" : "bg-red-500 hover:bg-red-600"
              }`}
            >
              {busy ? "Отвязываем…" : "Отвязать"}
            </button>
          </>
        )}

        {msg.ok && <div className="mt-2 text-green-700 bg-emerald-50 ring-1 ring-emerald-200 rounded px-3 py-2 text-sm">✓ {msg.ok}</div>}
        {msg.err && <div className="mt-2 text-rose-700 bg-rose-50 ring-1 ring-rose-200 rounded px-3 py-2 text-sm">{msg.err}</div>}

        {/* Добавляем ссылку на админ-бота */}
        <div className="mt-4">
          <a href="https://t.me/Mi64AdminBot" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">
            Открыть админ-бота
          </a>
        </div>
      </div>
    </section>
  );
}
